function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useEventTracker } from '@applyboard/ui-utils';
import { ErrorPageStyled, MessageStyled } from "./style";
import FourOOne from "./401";
import FourOThree from "./403";
import FourOFour from "./404";
import FourTwoTwo from "./422";
import FiveHundred from "./500";
function getErrorPage(errorCode) {
  var code = errorCode || 500;
  switch (Number(code)) {
    case 404:
      return FourOFour;
    case 422:
      return FourTwoTwo;
    case 401:
      return FourOOne;
    case 403:
      return FourOThree;
    default:
      return FiveHundred;
  }
}
var Portal = function Portal(_ref) {
  var children = _ref.children;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    nodeRef = _useState2[0],
    setNodeRef = _useState2[1];
  var parent = document.body;
  useEffect(function () {
    var portalNode = document.createElement('div');
    setNodeRef(portalNode);
    parent.appendChild(portalNode);
    return function () {
      parent.removeChild(portalNode);
    };
  }, []);
  if (!nodeRef) return null;
  return /*#__PURE__*/createPortal(children, nodeRef);
};
export var ErrorPage = function ErrorPage(_ref2) {
  var errorCode = _ref2.errorCode,
    customMessage = _ref2.customMessage;
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var Page = getErrorPage(errorCode);
  useEffect(function () {
    trackEvent({
      event: 'Error Page - User Encountered An Error Page',
      data: {
        errorCode: errorCode,
        customMessage: customMessage,
        referrer: document.referrer
      }
    });
  }, []);
  return /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(ErrorPageStyled, null, /*#__PURE__*/React.createElement(MessageStyled, null, /*#__PURE__*/React.createElement(Page, {
    customMessage: customMessage
  }))));
};